import { Component, ElementRef, HostBinding, HostListener, Input, OnInit } from '@angular/core';
import { Observable, combineLatest } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

import { BottomNavIconConfig, BottomNavIconsEnum } from './bottom-nav.models';
import { UserStore } from '../core-services/user/user.store';
import { VisitorStore } from '../core-services/visitor/visitor.store';
import { BaseComponent } from '../base.component';
import { UserDetails } from '../core-services/user/user.model';
import { MenuComponent } from '../menu/menu.component';
import { DeviceType } from '../core-services/visitor/visitor.model';
import { PageStore } from '../core-services/page/page.store';
import { GamesResultsComponent } from '../games-results/games-results.component';
import { ModalsStore } from '../core-services/modals/modals.store';
import { MenuTypes } from '../menu/menu.models';
import { PrefixLangs } from '../core-services/core.models';
import { GamesStore } from '../core-services/games/games.store';

export const BOTTOM_NAV_SELECTOR = 'whg-bottom-nav';

@Component({
    selector: BOTTOM_NAV_SELECTOR,
    templateUrl: './bottom-nav.component.html',
    styleUrls: ['./bottom-nav.component.scss'],
})
export class BottomNavComponent extends BaseComponent implements OnInit {
    @HostBinding('attr.role') role = 'navigation';
    @HostBinding('hidden') hidden = true;
    @HostListener('window:popstate', ['$event'])
    dismissModal() {
      this.modalService.dismissAll();
    }
    @Input() loggedIn: string;

    bottomNavConfig: BottomNavIconConfig[];
    supportedIcons = BottomNavIconsEnum;
    isLoggedIn: boolean;
    userDetails$: Observable<UserDetails>;

    constructor(
      private modalService: NgbModal,
      private userStore: UserStore,
      private visitorStore: VisitorStore,
      private pageStore: PageStore,
      private readonly modalsStore: ModalsStore,
      private gameStore: GamesStore,
      private element: ElementRef
    ) {
      super(PrefixLangs.BottomNav);
    }

    ngOnInit(): void {
       /*
      * Set language if any from the cookie, get configuration and listen for language switching
      */
      super.ngOnInit();
      this.config$.pipe(takeUntil(this.destroy$), filter(x => !!x)).subscribe((bottomNavConfig: BottomNavIconConfig[]) => {
        this.bottomNavConfig = bottomNavConfig;
      });

      this.isLoggedIn = JSON.parse(this.loggedIn);
      if(this.isLoggedIn) {
        this.userStore.addUserDetails(this.coreService.getUserDetails());
        this.userDetails$ = this.userStore.userDetails$.pipe(filter(x => !!x));
      }

      combineLatest([this.visitorStore.deviceType$, this.pageStore.page$])
        .pipe(takeUntil(this.destroy$))
        .subscribe(([deviceType, page]) => {
            this.hidden = deviceType === DeviceType.Desktop || page === 'login';
        });

      this.gameStore.numberOfGamesLessThanTen$
        .pipe(takeUntil(this.destroy$))
        .subscribe((isLessThanTen: boolean) => {
          if(isLessThanTen) {
            this.fixMarginBottomNav();
          }
        });
    }

    filterLoggedInIcons(): BottomNavIconConfig[] {
      if (this.bottomNavConfig) {
        if (this.isLoggedIn) {
            return this.bottomNavConfig;
        } else {
            return this.bottomNavConfig.filter(x => x.requiresLogin !== true);
          }
        } else return [];
    }

    openMenu(): void {
      this.isLoggedIn ?
        this.modalsStore.changeMenuModalConfig(MenuTypes.LoggedIn)
        :
        this.modalsStore.changeMenuModalConfig(MenuTypes.LoggedOut);
        this.modalService.open(MenuComponent, {
          ariaLabelledBy: "whg-menu-sections-title",
          windowClass: "whg-menu-sections-modal",
        })
    }

    openSearch(): void {
      // if we are not on a restricted page then open the search modal
      if(!this.coreService.isPageFromRestrictedList()) {
        const modalState = {
          modal : true,
          desc : 'modal opened'
        };
        history.pushState(modalState, null);
        this.modalService.open(GamesResultsComponent, {
          ariaLabelledBy: "search-modal-title",
          windowClass: "search-modal",
          backdrop : 'static',
          keyboard : false
        });
      }
    }

    restrictOnRegistration() {
      return this.coreService.isCurrentPathContains('create-account');
    }

    fixMarginBottomNav(): void {
      const parentNode = this.element.nativeElement.parentNode;
      parentNode.classList.add('whg-bottom-margin');
    }


}
